export default class Accordion {
    panelOpen = false;
}

document.addEventListener("alpine:init", () => {
    Alpine.data("faqAccordion", () => new Accordion());
});

import pegasus from "../../assets/scripts/global/01-pegasus.js";

document.addEventListener("alpine:init", () => {
    /**
     * FAQFilter Alpine component for search form
     */
    Alpine.data("FAQFilter", (term, options) => ({
        term: "",
        options: {},

        init() {
            this.term = term;
            this.options = JSON.parse(options);
            window.addEventListener("popstate", () => {
                if (window.history.state === null) {
                    location.reload();
                } else {
                    window.location = window.history.state.path;
                }
            });

            this.filterFAQs();
        },

        getUrlParam(name) {
            name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
            var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
            var results = regex.exec(location.search);
            return results === null
                ? ""
                : decodeURIComponent(results[1].replace(/\+/g, " "));
        },

        filterFAQs() {
            let searchUrl = this.options.wp_ajax_url;
            const category = this.getUrlParam("filter-t-faq-category");

            if (this.term !== "") {
                searchUrl += "?filter-search=" + this.term;
            }

            if (category) {
                searchUrl +=
                    (this.term === "" ? "?" : "&") +
                    "filter-t-faq-category=" +
                    category;
            }

            this.fetchContent(searchUrl);
        },

        fetchContent(url) {
            document.getElementById("LoadingScreen").style.display = "block";

            const elements = ['data-pegasus-filterable="results"'];
            pegasus.ajaxContent(url, elements, {}, () => {
                document.getElementById("LoadingScreen").style.display = "none";
                this.pushToHistory(document.title, url);

                this.updateSearchUI();
            });
        },

        /**
         * Check if the browser supports history
         * @returns {boolean}
         */
        historySupported() {
            return !!(window.history && history.pushState);
        },

        /**
         * pushing a title and an url into the history
         * @param title
         * @param url
         */
        pushToHistory(title, url) {
            if (this.historySupported()) {
                history.pushState({ path: url }, title, url);
            }
        },

        updateSearchUI() {
            const searchTermWrap = document.querySelector(
                ".js-accordion-search-term-wrap"
            );
            const searchTerm = searchTermWrap.querySelector(
                ".js-accordion-search-term"
            );
            const filters = document.querySelector(".js-filters");
            const faqs = document.querySelector(
                '[data-pegasus-filterable="results"]'
            );
            const noResults = document.querySelector(".js-no-results");

            if (this.term !== "") {
                searchTermWrap.style.display = "block";
                filters.style.display = "none";
                noResults.style.display = "none";
                searchTerm.innerHTML = this.term;
            } else {
                searchTermWrap.style.display = "none";
                window.innerWidth > 768 ? (filters.style.display = "flex") : "";
            }

            if (faqs && faqs.children.length === 0) {
                noResults.style.display = "block";
            } else {
                noResults.style.display = "none";
            }
        },
    }));

    /**
     * FAQSelector Alpine component for filter buttons
     */
    Alpine.data("FAQSelector", () => ({
        init() {
            window.addEventListener("popstate", () => {
                if (window.history.state === null) {
                    location.reload();
                } else {
                    window.location = window.history.state.path;
                }
            });
        },

        getUrlParam(name) {
            name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
            var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
            var results = regex.exec(location.search);
            return results === null
                ? ""
                : decodeURIComponent(results[1].replace(/\+/g, " "));
        },

        filterFAQs(root, filterValue) {
            let searchUrl = root;
            if (filterValue !== "") {
                searchUrl = root + "?filter-t-faq-category=" + filterValue;
            }
            const term = this.getUrlParam("filter-search");
            if (term) {
                searchUrl = searchUrl + "&filter-search=" + term;
            }
            const faqSelectors = document.querySelectorAll(".btn-faq-selector");
            faqSelectors.forEach(function (faqSelector) {
                faqSelector.classList.remove("filter-button--selected");
                faqSelector.classList.add("filter-button");
            });
            const faqSelected = document.querySelectorAll(
                ".btn-faq-selector--" + filterValue
            );
            faqSelected.forEach(function (faqSelector) {
                faqSelector.classList.remove("filter-button");
                faqSelector.classList.add("filter-button--selected");
            });
            this.fetchContent(searchUrl);
        },

        fetchContent(url) {
            const elements = ['data-pegasus-filterable="results"'];
            pegasus.ajaxContent(url, elements, {}, () => {
                document.getElementById("LoadingScreen").style.display = "none";
                this.pushToHistory(document.title, url);
            });
        },

        /**
         * Check if the browser supports history
         * @returns {boolean}
         */
        historySupported() {
            return !!(window.history && history.pushState);
        },

        /**
         * pushing a title and an url into the history
         * @param title
         * @param url
         */
        pushToHistory(title, url) {
            if (this.historySupported()) {
                history.pushState({ path: url }, title, url);
            }
        },
    }));
});
